export function loadCSS(href, id) {
  return new Promise((resolve) => {
    if (document.getElementById(id)) {
      resolve();
      return;
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.id = id;
    link.onload = resolve;
    link.onerror = resolve;
    document.head.appendChild(link);
  });
}

export function removeCSS(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

export function loadScript(src, id) {
  return new Promise((resolve) => {
    if (document.getElementById(id)) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.id = id;
    script.onload = resolve;
    script.onerror = resolve;
    document.body.appendChild(script);
  });
}

export function removeScript(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}
